export const Stat = ({ k, v, sub, testid }) => (
  <div className="border border-[var(--line)] px-4 py-4" data-testid={testid}>
    <p className="label">{k}</p>
    <p className="mt-2 font-data text-2xl tabular-nums leading-none text-zinc-100">{v}</p>
    {sub && <p className="mt-2 font-data text-[10px] text-zinc-600">{sub}</p>}
  </div>
);

export default Stat;
